export default "__VITE_PUBLIC_ASSET__c0850f5e__"